import GenericDB from './generic-db'

export default class UserSettingsDB extends GenericDB {
  constructor() {
    super(`settings/`)
  }

  // Here you can extend UserDashboardDB with custom methods
  checking = () => {
    console.log('checking')
  }
}
